import React from "react";
import styles from "./MobileSignUp.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import facebook from "../../../assets/images/Facebook.png";
import google from "../../../assets/images/google1.png";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "../../../components/Hooks/axios";
import { addAccount } from "../../../redux/slices/accountSlice";
import { logOut, setAuth, setUserObject } from "../../../redux/slices/authSlice";
import FacebookLogin from "@greatsumini/react-facebook-login";
import {
	validateSignUp,
	validateName,
	validateEmail,
	validateGender,
	validateDob,
	validatePassword,
	validateConfirmPassword,
	getPasswordCriteria,
	getMaxDobDate,
} from "../../../utils/authValidation";
import { setTempEmail } from "../../../redux/slices/tempSlice";
import LoadingBg from "../Loading Bg/LoadingBg";
import logo from "../../../assets/images/mainlogo1.png";

const MobileSignUp = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [gender, setGender] = useState("");
	const [showGender, setShowGender] = useState(false);
	const [DOB, setDOB] = useState("");
	const [password, setPassword] = useState("");
	const [conPassWord, setConPassWord] = useState("");
	const [errors, setErrors] = useState({});
	const [touched, setTouched] = useState({});
	const [btnDisabled, setBtnDisabled] = useState(false);
	const [passIcon1, setPassIcon1] = useState(false);
	const [passIcon2, setPassIcon2] = useState(false);

	const location = useLocation();
	const isSignupPage = location.pathname === "/signup";

	const pwdCriteria = getPasswordCriteria(password);

	const handleBlur = (field) => {
		setTouched((prev) => ({ ...prev, [field]: true }));
		let err = "";
		if (field === "name") err = validateName(name);
		else if (field === "email") err = validateEmail(email);
		else if (field === "gender") err = validateGender(gender);
		else if (field === "dob") err = validateDob(DOB);
		else if (field === "password") err = validatePassword(password);
		else if (field === "conPassWord") err = validateConfirmPassword(password, conPassWord);

		setErrors((prev) => ({ ...prev, [field]: err }));
	};

	const handleNameChange = (e) => {
		const val = e.target.value;
		setName(val);
		if (touched.name || errors.name) {
			setErrors((prev) => ({ ...prev, name: validateName(val) }));
		}
	};

	const handleEmailChange = (e) => {
		const val = e.target.value;
		setEmail(val);
		if (touched.email || errors.email) {
			setErrors((prev) => ({ ...prev, email: validateEmail(val) }));
		}
	};

	const handleGenderSelect = (selectedGender) => {
		setGender(selectedGender);
		setShowGender(false);
		setTouched((prev) => ({ ...prev, gender: true }));
		if (touched.gender || errors.gender) {
			setErrors((prev) => ({ ...prev, gender: validateGender(selectedGender) }));
		}
	};

	const handleDobChange = (e) => {
		const val = e.target.value;
		setDOB(val);
		setTouched((prev) => ({ ...prev, dob: true }));
		setErrors((prev) => ({ ...prev, dob: validateDob(val) }));
	};

	const handlePasswordChange = (e) => {
		const val = e.target.value;
		setPassword(val);
		if (touched.password || errors.password) {
			setErrors((prev) => ({ ...prev, password: validatePassword(val) }));
		}
		if (touched.conPassWord || conPassWord) {
			setErrors((prev) => ({ ...prev, conPassWord: validateConfirmPassword(val, conPassWord) }));
		}
	};

	const handleConPasswordChange = (e) => {
		const val = e.target.value;
		setConPassWord(val);
		if (touched.conPassWord || errors.conPassWord) {
			setErrors((prev) => ({ ...prev, conPassWord: validateConfirmPassword(password, val) }));
		}
	};

	const handelSubmit = (e) => {
		if (e && e.preventDefault) e.preventDefault();

		const cleanName = name.trim();
		const cleanEmail = email.trim();

		setTouched({
			name: true,
			email: true,
			gender: true,
			dob: true,
			password: true,
			conPassWord: true,
		});

		const { isValid, errors: validationErrors } = validateSignUp({
			name: cleanName,
			email: cleanEmail,
			gender,
			dob: DOB,
			password,
			conPassWord,
		});

		if (!isValid) {
			setErrors(validationErrors);
			const firstError = Object.values(validationErrors)[0];
			if (firstError) toast.warn(firstError);
			return;
		}

		setErrors({});
		setBtnDisabled(true);

		const data = JSON.stringify({
			username: cleanName,
			email: cleanEmail,
			dob: DOB,
			gender,
			password: password,
			uniqueName: cleanName + "_" + Date.now(),
		});

		// Clear any previous stale session before starting a new sign up
		dispatch(logOut());

		axios
			.post("/auth/register", data, {
				headers: {
					"Content-Type": "application/json",
				},
			})
			.then(({ data }) => {
				setTimeout(() => {
					toast.success(data.message);
					setBtnDisabled(false);
					if (data.otp) {
						toast.info(`OTP: ${data.otp}`, {
							autoClose: 12000,
						});
					}
					toast.success("SignUp Success");
					dispatch(setTempEmail(cleanEmail));
					navigate("/verification-code", {
						state: {
							signUp: true,
							email: cleanEmail,
						},
						replace: true,
					});
				}, 300);
			})
			.catch(({ response }) => {
				const errMsg = response?.data?.error || response?.data?.message || "Sign up failed";
				toast.error(errMsg);
				setBtnDisabled(false);
			});
	};

	const login = useGoogleLogin({
		onSuccess: (tokenResponse) => {
			axios
				.get(`https://www.googleapis.com/oauth2/v3/userinfo`, {
					headers: {
						Authorization: `Bearer ${tokenResponse.access_token}`,
					},
				})
				.then(({ data }) => {
					axios
						.post("/auth/googleRegister", data)
						.then(({ data }) => {
							if (data.status) {
								dispatch(setAuth({ userId: data.data._id, token: data.token }));
								dispatch(setUserObject(data.data));
								axios.defaults.headers.Authorization = data.token;
								setBtnDisabled(false);
								dispatch(addAccount({ userId: data.data._id, user: data.data, token: data.token }));
								navigate("/interest", { replace: true });
							}
						})
						.catch((e) => {
							console.log(e);
							toast.error("Google Sign-Up Failed");
						});
				})
				.catch((e) => console.log(e));
		},
		onError: (tokenResponse) => console.log(tokenResponse),
	});

	const responseFacebook = (response) => {
		console.log("Facebook Response:", response);
		if (response.accessToken) {
			axios
				.post("/auth/facebookRegister", response)
				.then(({ data }) => {
					if (data.status) {
						dispatch(setAuth({ userId: data.data._id, token: data.token }));
						axios.defaults.headers.Authorization = data.token;
						setBtnDisabled(false);
						navigate("/interest", { replace: true });
					}
				})
				.catch((e) => {
					console.log(e);
					toast.error("Facebook Sign-Up Failed");
				});
		}
	};

	return (
		<div className={styles.mainContainer}>
			{isSignupPage ? (
				<>
					<div className={styles.singupLogo}> 
					<img src={logo} alt="logoImg" className={styles.Logo} />
					</div>
				</>
			) : (
				<LoadingBg />
			)
			}

			<form className={styles.form} onSubmit={handelSubmit} noValidate>
				<div className={styles.buttons}>
					<button type="button" className={`${styles.signInButton} ${styles.activeButton}`}>Sign Up</button>
					<button
						type="button"
						className={styles.signInButton}
						onClick={() => {
							navigate("/signin");
						}}>
						Sign In
					</button>
				</div>

				<div className={styles.inputContainer}>
					<div className={styles.input}>
						<label className={styles.label}>Name</label>
						<input
							type="text"
							className={`${styles.inputBox} ${touched.name && errors.name ? styles.inputError : ""}`}
							value={name}
							placeholder="Enter Your Name"
							onChange={handleNameChange}
							onBlur={() => handleBlur("name")}
						/>
						{touched.name && errors.name && (
							<span className={styles.errorMessage}>{errors.name}</span>
						)}
					</div>

					<div className={styles.input}>
						<label className={styles.label}>E-mail</label>
						<input
							type="email"
							className={`${styles.inputBox} ${touched.email && errors.email ? styles.inputError : ""}`}
							value={email}
							placeholder="Enter Your Email"
							onChange={handleEmailChange}
							onBlur={() => handleBlur("email")}
						/>
						{touched.email && errors.email && (
							<span className={styles.errorMessage}>{errors.email}</span>
						)}
					</div>

					<div className={`${styles.input} ${styles.gender}`}>
						<label className={styles.label}>Gender</label>
						<div className={styles.customSelectContainer}>
							<div
								className={`${styles.inputBox} ${touched.gender && errors.gender ? styles.inputError : ""}`}
								onClick={() => setShowGender(!showGender)}
								style={{
									cursor: "pointer",
									display: "flex",
									justifyContent: "space-between",
									alignItems: "center",
									color: gender ? "black" : "#959595",
									fontSize: "2.2rem"
								}}
							>
								{gender ? gender.charAt(0).toUpperCase() + gender.slice(1) : "Select a Gender"}
								<span style={{ fontSize: "2rem", transition: "transform 0.3s", transform: showGender ? "rotate(180deg)" : "rotate(0deg)", color: "black" }}>▼</span>
							</div>
							{showGender && (
								<div className={styles.optionsList}>
									<div
										className={styles.option}
										onClick={() => handleGenderSelect("male")}
									>
										Male
									</div>
									<div
										className={styles.option}
										onClick={() => handleGenderSelect("female")}
									>
										Female
									</div>
								</div>
							)}
						</div>
						{touched.gender && errors.gender && (
							<span className={styles.errorMessage}>{errors.gender}</span>
						)}
					</div>

					<div className={`${styles.input} ${styles.dob}`}>
						<label className={styles.label}>Date of birth</label>
						<input
							type="date"
							max={getMaxDobDate()}
							className={`${styles.inputBox} ${touched.dob && errors.dob ? styles.inputError : ""}`}
							value={DOB}
							onChange={handleDobChange}
							onBlur={() => handleBlur("dob")}
						/>
						{touched.dob && errors.dob && (
							<span className={styles.errorMessage}>{errors.dob}</span>
						)}
					</div>

					<div className={styles.passwordWrapper}>
						<div className={styles.input}>
							<label className={styles.label}>New password</label>

							<div className={`${styles.inputPass} ${touched.password && errors.password ? styles.inputError : ""}`}>
								<input
									type={passIcon1 ? "text" : "password"}
									placeholder="Enter Your Password"
									value={password}
									onChange={handlePasswordChange}
									onBlur={() => handleBlur("password")}
								/>
								<span onClick={() => setPassIcon1(!passIcon1)}>
									{passIcon1 ? <FaEye size={"2.5rem"} /> : <FaEyeSlash size={"2.5rem"} />}
								</span>
							</div>
							{touched.password && errors.password && (
								<span className={styles.errorMessage}>{errors.password}</span>
							)}

							<div className={styles.pwdRequirements}>
								<span className={`${styles.reqItem} ${pwdCriteria.minLength ? styles.valid : styles.invalid}`}>
									{pwdCriteria.minLength ? "✓" : "•"} 8+ chars
								</span>
								<span className={`${styles.reqItem} ${pwdCriteria.hasUppercase ? styles.valid : styles.invalid}`}>
									{pwdCriteria.hasUppercase ? "✓" : "•"} Uppercase
								</span>
								<span className={`${styles.reqItem} ${pwdCriteria.hasNumber ? styles.valid : styles.invalid}`}>
									{pwdCriteria.hasNumber ? "✓" : "•"} Number
								</span>
								<span className={`${styles.reqItem} ${pwdCriteria.hasSpecialChar ? styles.valid : styles.invalid}`}>
									{pwdCriteria.hasSpecialChar ? "✓" : "•"} Special char
								</span>
							</div>
						</div>

						<div className={styles.input}>
							<label className={styles.label}>Re-type password</label>
							<div className={`${styles.inputPass} ${touched.conPassWord && errors.conPassWord ? styles.inputError : ""}`}>
								<input
									type={passIcon2 ? "text" : "password"}
									placeholder="Confirm Password"
									value={conPassWord}
									onChange={handleConPasswordChange}
									onBlur={() => handleBlur("conPassWord")}
								/>
								<span onClick={() => setPassIcon2(!passIcon2)}>
									{passIcon2 ? <FaEye size={"2.5rem"} /> : <FaEyeSlash size={"2.5rem"} />}
								</span>
							</div>
							{touched.conPassWord && errors.conPassWord && (
								<span className={styles.errorMessage}>{errors.conPassWord}</span>
							)}
						</div>
					</div>
					<div className={styles.submitButtonContainer}>
						<button
							type="submit"
							className={`${styles.signInButton} ${styles.activeButton} ${styles.submitButton}`}
							disabled={btnDisabled}>
							Sign Up
						</button>
					</div>
				</div>

				<div className={styles.design}>
					<p className={styles.continue}>Continue With</p>
				</div>

				<div className={styles.footer}>
					<button type="button" onClick={() => login()} title="Sign up with Google">
						<img src={google} alt="Google" className={styles.google} />
					</button>
					<FacebookLogin
						appId={`${process.env.REACT_APP_FACEBOOK_APP_ID}`}
						autoLoad={false}
						fields="name,email,picture"
						callback={responseFacebook}
						render={(renderProps) => (
							<button type="button" onClick={renderProps.onClick} title="Sign up with Facebook">
								<img src={facebook} alt="Facebook" className={styles.facebook} />
							</button>
						)}
					/>
				</div>
			</form>
		</div >
	);
};


export default MobileSignUp;


